import React from 'react';

import classNames from 'classnames';

import { attentionCards, TONE_RED } from './homeAttention';

/**
 * "Needs your attention": one card per exception the user actually has.
 *
 * THE STRIP DISAPPEARS WHEN THERE IS NOTHING IN IT, heading and all. An empty
 * "Needs your attention" with a reassuring message under it is still a block of
 * page asking to be read every morning, and the tiles below already say the
 * queue is clear.
 *
 * A CARD IS A BUTTON, not a link. Every one of them opens a list further down
 * this same page, so there is no URL for it to carry — and a button is what a
 * screen reader should announce for something that changes the page it is on.
 */
export default function HomeAttentionStrip({ counts, deltas, onOpen }) {
    const cards = attentionCards(counts, deltas);

    if (cards.length === 0) {
        return null;
    }

    return (
        <section aria-labelledby="home-attention">
            <h2 id="home-attention" className="tw-mb-2.5 tw-text-sm tw-font-semibold tw-text-charcoal">
                {$t('Needs your attention')}
            </h2>

            {/* auto-fit rather than a fixed column count: the strip holds
                anything from one card to six, and a fixed grid would leave a
                lone card stretched across the page. */}
            <div className="tw-grid tw-gap-3 tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-6">
                {cards.map((card) => {
                    const red = card.tone === TONE_RED;

                    return (
                        <button
                            key={card.key}
                            type="button"
                            onClick={() => onOpen?.(card.type)}
                            className={classNames(
                                'tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-px-4 tw-py-3.5 tw-text-start',
                                red ? 'tw-bg-red-10' : 'tw-bg-amber-100',
                            )}
                        >
                            <span
                                className={classNames(
                                    'tw-row-span-2 tw-text-2.5xl tw-font-bold tw-leading-none',
                                    red ? 'tw-text-red-600' : 'tw-text-amber-700',
                                )}
                            >
                                {card.value}
                            </span>
                            <span className="tw-text-0.5sm tw-font-medium tw-text-charcoal">{card.label}</span>
                            {/* The second grid row is only drawn when there is a
                                detail to put in it, so a card without one keeps
                                its number vertically centred against the label
                                rather than against an empty line. */}
                            {!!card.detail && <span className={classNames('tw-text-xs', red ? 'tw-text-red-600' : 'tw-text-amber-700')}>{card.detail}</span>}
                        </button>
                    );
                })}
            </div>
        </section>
    );
}
